import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { PaymentService } from '../services/payment.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpClient } from '@angular/common/http';
import { CompanyDetailsService } from '../services/company-details.service';
import { UserService } from '../services/user.service';
import { LoaderService } from '../services/loader.service';
import { MatDialog } from '@angular/material/dialog';
import { PayperbyteWarnDialogComponent } from '../payperbyte-warn-dialog/payperbyte-warn-dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PaymentDialogComponent } from '../payment-dialog/payment-dialog.component';
import { LogService } from '../services/log.service';
@Component({
    selector: 'app-pay-tuition',
    templateUrl: './pay-tuition.component.html',
    styleUrls: ['./pay-tuition.component.css']
})
export class PayTuitionComponent implements OnInit {
    public feeDetail = [];
    public sessionYear = '';
    public term = '';
    public total = 0;
    public paymentGateway = '';
    public tuitionPaid;
    public charge = 0;

    public hasCheckedAdded = false;
    public totalAdded = 0;
    public fullName = "";
    public message = "";
    public companyAccounts = [];
    public pay_key = "";
    constructor (public _http: HttpClient, private _paymentService: PaymentService, public _userService: UserService, private spinner: NgxSpinnerService, private http: HttpClient, private CompanyDetailsService: CompanyDetailsService, public _loaderService: LoaderService, public dialog: MatDialog, public snackbar: MatSnackBar, public log: LogService) { }

    public paymentOptions: any;
    public paymentHistory = [];

    public hasSwitch = false;
    public hasPaystack = false;
    public hasWallet = false;

    public partPayment = { control: false, value: 0 };
    public payOption = 'full';
    sequential_invoice_payment = true;

    //INTERSWITCH DETAILS
    public product_id = "0";
    public site_redirect_url = "http://localhost:8080/ntertP/edozzier/portal-interswitch-response.php";
    public pay_item_id = "101";
    public split_data = "101";
    public hash = "1612a2a6324f12077b0c8b2f427d159169b684249f02b0fac2cb457bfa19a4350cfc320f85c2789ac4953708b404d735b5cbd2e90588d28d441d4eb5f9a54066";
    public interswitchCharge = 300;
    public payment_option = []
    public hasOnline = false;
    public hasSlipUpload = false;

    @ViewChild("switchForm") switchForm: ElementRef;
    ngOnInit () {
        // this._paymentService.getPaymentPercentage().subscribe(data => {
        //     // console.log(data);
        //     this.
        // })
        this.log.addLog({
            action: "Access",
            component: "Tuition Payment",
            details: `Accessed Tuition Payment Page`
        }).subscribe();


        this.getUserData();
    }

    user;
    getUserData () {
        this._userService.getUserData().subscribe(user => {
            this.fullName = user.firstname.toUpperCase() + " " + user.lastname.toUpperCase();
            this.user = user;
            //   this.paymentOptions.customerName = this.fullName;
            //   this.paymentOptions.customerEmail = data.email;

            this._paymentService.getPaymentControls().subscribe(data => {
                // fresher / staylite
                let controlKey = "";
                if (user.rank == 1) {
                    controlKey = "part_payment_fresher";
                } else if (!user.rank || user.rank > 1) {
                    controlKey = "part_payment_staylite";
                }

                let part = data.find(d => d.control_key == controlKey);
                if (part) {
                    this.partPayment = { control: true, value: part.control_value };
                } else {
                    this.partPayment = { control: false, value: 0 }
                }

                this.paymentHistory.length = 0;
                // this.getPaymentGateway();

                this.CompanyDetailsService.getDetails().subscribe(data => {

                    this.payment_option = JSON.parse(data.payment_option);
                    this.hasOnline = this.payment_option.includes('Online');
                    this.hasSlipUpload = this.payment_option.includes('Slip Upload');

                    this.paymentGateway = data.payment_gateway;
                    this.sequential_invoice_payment = !!Number(data.sequential_invoice_payment); // to boolean
                    this.pay_key = data.pay_key;

                    if (this.paymentGateway.toLowerCase().includes('interswitch')) {
                        this.hasSwitch = true
                    }

                    if (this.paymentGateway.toLowerCase().includes('paystack')) {
                        this.hasPaystack = true
                    }

                    if (this.paymentGateway.toLowerCase().includes('wallet')) {
                        this.hasWallet = true;
                    }

                    this.isTuitionPaid();

                    this._paymentService.studentPaymentHistory().subscribe(data => {
                        this._loaderService.emitChange(false);
                        this.paymentHistory = data;
                        this.updatePays(true);
                    })
                    if (this.paymentGateway == 'wallet') {
                        this._paymentService.getCompanyAccounts().subscribe(data => {
                            this.companyAccounts = data.data;
                        })
                    }
                })
            })

        })
    }

    updatePays (updateAmount = false) {
        this.paymentHistory = this.paymentHistory.map(d => {
            if (updateAmount) {
                d.custom_amount = d.custom_amount ?? d.amount_remaining;
            }

            d.paymentOptions = {
                merchantCode: 'MX18777',
                payItemID: 'Default_Payable_MX18777',
                transactionReference: Date.now().toString(),
                amount: `${(d.custom_amount + this.interswitchCharge) * 100}`,
                customerEmail: this.user.email,
                customerName: this.fullName,
                paymentMode: 'LIVE'
            }

            if (this.paymentGateway.includes('interswitch')) {
                d.charge = this.interswitchCharge;
            }

            if (this.paymentGateway.includes('paystack')) {
                let charge = (d.custom_amount * 1.5 / 100) + 100;
                d.paystack_charge = Math.round(charge < 2000 ? charge : 2000);
            }

            if (this.paymentGateway.includes('wallet')) {
                d.wallet_charge = 150;
            }

            // d.amount = d.custom_amount + d.charge
            d.minimum = (this.partPayment.value / 100) * d.amount_remaining

            // if part payment is allowed and yuo no wan pay less than amount allpwed

            // if (this.partPayment) {
            //     let new_amount = ;
            //     let charge = (new_amount * 1.5 / 100) + 100;
            //     d.part_charge = charge < 2000 ? charge : 2000;
            //     d.part_pay = new_amount;
            // }

            return d;
        })
    }

    changePayOption () {
        this.paymentHistory.map(pay => {
            if (this.payOption == 'part') {
                // pay.paymentOptions.amount = (((this.partPayment.value/100) * pay.amount_remaining)) * 100
                pay.paymentOptions.amount = (((this.partPayment.value / 100) * pay.amount_remaining) + this.interswitchCharge) * 100
            } else if (this.payOption == 'full') {
                pay.paymentOptions.amount = (pay.amount_remaining + this.interswitchCharge) * 100;
            }
        })
    }

    disabledInvoice (pay, i) {
        const olderBalance = this.paymentHistory.filter((each, _i) => each.invoice_id != pay.invoice && i < _i).reduce((a, b) => a + b.amount_remaining, 0);
        return olderBalance > 0 && this.sequential_invoice_payment;
    }

    invoiceClicked (pay, i) {
        if (!this.disabledInvoice(pay, i)) return;
        this.snackbar.open("You are required to balance older invoice(s)!", "Dismiss", { duration: 3000 });
    }

    // getFeeDetails(){
    //     this._paymentService.getFeeDetails().subscribe(data => {
    //         this.feeDetail = data;
    //         if(!data[0]){
    //             this.message = "You do not have any payment to make yet";
    //         }
    //         this.sessionYear = data[0].session_year;
    //         this.term = data[0].term;

    //         //get total fees
    //         this.feeDetail.map(f => {
    //             this.total += f.amount
    //         });

    //         // this.getAddedPayment(this.feeDetail[0].inv_id);

    //         this._loaderService.emitChange(false);
    //     })
    // }

    // getAddedPayment(inv_id){
    //     let form = new FormData;
    //     form.append("inv_id", inv_id);
    //     this._paymentService.getAddedPayment(form).subscribe(data => {
    //         this.hasCheckedAdded = true;
    //         let added = data;
    //         let totalAdded = 0;
    //         added.map(ad => {
    //             totalAdded += ad.amount_paid;
    //         })

    //         this.totalAdded = totalAdded;
    //         if(this.paymentGateway == 'interswitch'){
    //             this.charge = 300;
    //         }else if(this.paymentGateway == 'paystack'){
    //             let newTotal = this.total-this.totalAdded;
    //             // console.log(this.total, "TOT")
    //             let charge = (newTotal * 1.6/100) + 100;
    //             if(newTotal > 0){
    //                 this.charge = charge < 2000 ? charge : 2000;
    //             }else{
    //                 this.charge = 0
    //             }
    //         }else if(this.paymentGateway == 'wallet'){
    //             this.charge = 150
    //         }

    //         this.paymentOptions.amount = this.total - this.totalAdded + this.charge;
    //     })
    // }

    isTuitionPaid () {
        this._paymentService.tuitionPaid().subscribe(data => {
            this.tuitionPaid = data.paid;
            // this.getFeeDetails();
        })
    }

    // getPaymentGateway(){
    //     this.CompanyDetailsService.getDetails().subscribe(data => {
    //         this.paymentGateway = data.payment_gateway;
    //         this.isTuitionPaid();

    //         if(this.paymentGateway == 'wallet'){
    //             this._paymentService.getCompanyAccounts().subscribe(data => {
    //                 this.companyAccounts = data.data;
    //             })
    //         }
    //     })
    // }

    // handleInterswitchPayment(){
    //     this._paymentService.handleInterswitchPayment().subscribe(data => {
    //         console.log('data: ', data);
    //     })
    // }

    transferPayment () {
        // this.getUserData()
        const dialogRef = this.dialog.open(PaymentDialogComponent, {
            width: '70%',
            data: { paymentHistory: this.paymentHistory }
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result) {

                this.getUserData()
            }
        })
    }

    handlePaymentUpload (pay) {
        let charge = 150;
        let amount = 0;
        let withoutCharge = 0;
        // amount = pay.amount_remaining;
        if (this.payOption == 'part') {
            amount = pay.part_pay + charge;
            withoutCharge = pay.part_pay;

        } else {
            amount = pay.amount_remaining + charge;
            withoutCharge = pay.amount_remaining
        }
        let form = {
            amount, payment: 'tuition', withoutCharge: pay.amount_remaining,
            inv_id: pay.invoice_id, student_name: this.fullName,
            fee_details: pay.invoice_details
        };

        const dialogRef = this.dialog.open(PayperbyteWarnDialogComponent, {
            width: '550px',
            data: { for: 'pay_upload', pay, form }
        });

        dialogRef.afterClosed().subscribe(result => {
            this._loaderService.emitChange(true)
            if (typeof (result) === 'undefined') {
                this._loaderService.emitChange(false)
                // alert();
            }
            else {
                this._paymentService.makePaymentByReference({ ...form, reference: result }).subscribe(data => {
                    this._loaderService.emitChange(false)
                    if (data.success) {
                        this.snackbar.open("Payment made successfully!", "Dismiss");
                        this.log
                            .addLog({
                                action: "Pay",
                                component: "Pay Tuition",
                                details: `Made Payment - ${amount} with reference - ${result}`
                            }).subscribe(data => { });
                        this.ngOnInit();
                    } else {
                        this.snackbar.open("An error occured, please try again or contact admin")
                    }
                })
            }
        })
    }

    testInterswitch (pay) {
        return;
        let resp = {
            "payRef": "GTB|WEB|MX18777|23-02-2023|990675286|835016",
            "txnref": "1677137419648",
            "amount": 40000,
            "apprAmt": 40000,
            "resp": "00",
            "desc": "Approved by Financial Institution",
            "retRef": "158031050600",
            "cardNum": "",
            "mac": ""
        };

        console.log(resp);
        let amount = resp.amount;
        let withoutCharge = (amount / 100) - this.interswitchCharge;
        // withoutCharge = withoutCharge * 100;
        let form = {
            amount, payment: 'tuition', withoutCharge: withoutCharge,
            inv_id: pay.invoice_id, student_name: this.fullName,
            fee_details: pay.invoice_details, reference: resp.txnref, termd_id: pay.termd_id
        };

        if (resp.resp == '00') {
            this._loaderService.emitChange(true)
            this._paymentService.recordPayment(form).subscribe(data => {
                this._loaderService.emitChange(false)
                if (data.success) {
                    this.snackbar.open("Payment Recorded Successfully", "Dismiss", {
                        duration: 5000
                    });
                    this.ngOnInit();
                }
            })
        } else {
            this.snackbar.open("Something went wrong, please try again", "Dismiss", {
                duration: 5000
            });
            this.ngOnInit();
        }
    }

    handlePaymentInterswitch (resp, pay) {
        // console.log(resp);
        let amount = resp.amount;
        let withoutCharge = (amount / 100) - this.interswitchCharge;
        // withoutCharge = withoutCharge * 100;
        let form = {
            amount, payment: 'tuition', withoutCharge: withoutCharge,
            inv_id: pay.invoice_id, student_name: this.fullName,
            fee_details: pay.invoice_details, reference: resp.txnref, termd_id: pay.termd_id
        };

        if (resp.resp == '00') {
            this._loaderService.emitChange(true)
            this._paymentService.recordPayment(form).subscribe(data => {
                this._loaderService.emitChange(false)
                if (data.success) {
                    this.snackbar.open("Payment Recorded Successfully", "Dismiss", {
                        duration: 5000
                    });
                    this.log
                        .addLog({
                            action: "Pay",
                            component: "Pay Tuition",
                            details: `Made Payment through Interswitch - ${amount} with reference - ${resp.txnref}`
                        }).subscribe(data => { });
                    this.ngOnInit();
                }
            })
        } else {
            this.snackbar.open("Something went wrong, please try again", "Dismiss", {
                duration: 5000
            });
            this.ngOnInit();
        }
    }

    handlePaymentPaystack (pay) {
        const amount = pay.custom_amount;
        // + pay.paystack_charge; // charge is being clcukated on the backend now

        if (pay.custom_amount < pay.minimum && this.partPayment.control) {
            this.snackbar.open(`You can't pay less than ${pay.minimum.toLocaleString()}`, "Dismiss")
            return;
        }

        let form = {
            amount: Math.round(amount), payment: 'tuition',
            inv_id: pay.invoice_id, student_name: this.fullName,
            fee_details: pay.invoice_details
        };

        if (pay.custom_amount == 0) {
            alert("Nothing to pay");
            return;
        }

        this._loaderService.emitChange(true);
        return this._paymentService.makeAppPayment(form).subscribe((data: any) => {
            if (!data.red_url) { this._loaderService.emitChange(false); return; }

            location.href = data.red_url;
            this.log.addLog({
                action: "Initiate",
                component: "Pay Tuition",
                details: `Initiated a Payment through Paystack - ${amount} with invoice details - ${pay.invoice_details}`
            }).subscribe();
        }, () => {
            this._loaderService.emitChange(false);
        })
    }

    handlePaymentWallet (pay) {
        let charge = 150;
        let amount = pay.custom_amount + charge;

        let form = {
            amount, payment: 'tuition', withoutCharge: pay.custom_amount,
            inv_id: pay.invoice_id, student_name: this.fullName,
            fee_details: pay.invoice_details
        };

        const dialogRef = this.dialog.open(PayperbyteWarnDialogComponent, {
            minWidth: '30%',
            data: { warning: true, paying: false, for: 'wallet', pay: { amount, accounts: this.companyAccounts } }
        });

        dialogRef.afterClosed().subscribe(result => {
            this._loaderService.emitChange(true)
            if (typeof (result) === 'undefined') {
                this._loaderService.emitChange(false)
                // alert();
            }
            else {
                this._paymentService.makePaymentByReference({ ...form, reference: result }).subscribe(data => {
                    this._loaderService.emitChange(false)
                    if (data.success) {
                        this.snackbar.open("Payment made successfully!");
                        this.log
                            .addLog({
                                action: "Pay",
                                component: "Pay Tuition",
                                details: `Made Payment through wallet - ${amount} with reference - ${result}`
                            }).subscribe(data => { });
                        this.ngOnInit();
                    } else {
                        this.snackbar.open("An error occured, please try again or contact admin")
                    }
                })
            }
        })
    }

    // handlePayment(pay) {
    //     let amount = pay.amount_remaining + pay.charge;
    //     let form = {
    //         amount, payment: 'tuition', withoutCharge: pay.amount_remaining, 
    //         inv_id: pay.invoice_id, student_name: this.fullName,
    //         fee_details: pay.invoice_details
    //     };
    //     if(this.paymentGateway == 'paystack'){
    //         this._loaderService.emitChange(true);

    //         if(amount == 0) {
    //             alert("Nothing to pay");
    //             return;
    //         }
    //         return this._paymentService.makeAppPayment(form).subscribe((data: any) => {
    //             location.href = data.red_url;
    //         })
    //     }else if(this.paymentGateway == 'wallet'){
    //         const dialogRef = this.dialog.open(PayperbyteWarnDialogComponent,{
    //             minWidth:'30%',
    //             data : {warning: true, paying: false, for: 'wallet', pay: {amount, accounts: this.companyAccounts}}
    //         });

    //         dialogRef.afterClosed().subscribe(result => {
    //             this._loaderService.emitChange(true)
    //             if(typeof(result) === 'undefined'){
    //                 this._loaderService.emitChange(false)
    //                 // alert();
    //             }
    //             else{
    //                 this._paymentService.makePaymentByReference({...form, reference: result}).subscribe(data => {
    //                     this._loaderService.emitChange(false)
    //                     if(data.success){
    //                         this.snackbar.open("Payment made successfully!");
    //                         this.ngOnInit();
    //                     }else{
    //                         this.snackbar.open("An error occured, please try again or contact admin")
    //                     }
    //                 })
    //             }
    //         })
    //     }
    // }


}
